<!-- app设置 -->
<template>
  <div>
    <div class="searchBox" ref="searchBox">
      <el-form
        :inline="true"
        :model="searchFrom"
        ref="searchFrom"
        class="demo-form-inline"
        label-width="120px"
        size="mini"
      >
        <el-form-item label="属性编码:" prop="attributeFlag">
          <el-input
            placeholder=""
            maxlength="100"
            v-model="searchFrom.attributeFlag"
          ></el-input>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      h: '500px',
      searchFrom: {
        pageNo: 1,
        pageSize: 50
      }
    }
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = pH - h - 92 + 'px'
  }
}
</script>
<style lang="less" scoped></style>
